document.addEventListener('DOMContentLoaded', function() {
  const variantImageSwatches = document.querySelectorAll('[data-variant-image-swatch]');
  
  variantImageSwatches.forEach(swatch => {
    const input = swatch.querySelector('input[type="radio"]');
    
    input.addEventListener('change', function() {
      if (this.checked) {
        const value = this.value;
        const productPhotos = document.querySelector('#product__photo, .product__photo');
        
        // Find the variant with this option value
        const productData = window.productData || {};
        if (productData.variants) {
          const matchingVariant = productData.variants.find(variant => 
            variant.options.includes(value)
          );
          
          if (matchingVariant && matchingVariant.featured_media) {
            // Update main product image
            const mainImage = productPhotos?.querySelector('img');
            if (mainImage && matchingVariant.featured_media.preview_image) {
              const newImageUrl = matchingVariant.featured_media.preview_image.src;
              mainImage.src = newImageUrl;
              mainImage.srcset = '';
            }
          }
        }
      }
    });
  });
});